var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.showSidebar)?_c('div',{staticClass:"standard-sidebar d-none d-sm-block"},[_vm._t("sidebar")],2):_vm._e(),_c('div',{staticClass:"standard-page"},[_vm._t("page")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }